export default "__VITE_ASSET__b1daaa4f__"